import { render, staticRenderFns } from "./topGameBannerInEvents.vue?vue&type=template&id=55b14840&scoped=true&"
import script from "./topGameBannerInEvents.vue?vue&type=script&lang=js&"
export * from "./topGameBannerInEvents.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55b14840",
  null
  
)

export default component.exports